import type { Ref } from "react";
import type { SpeakerRole } from "@shared/ocenaTypy.js";
import { MAX_ZNAKOW_NAZWY_MOWCY, ROLE_DO_WYBORU } from "../../lib/podzial.js";
import { Field, Input } from "../ui/Field.js";
import { type OpcjaSelect, Select } from "../ui/Select.js";

const OPCJE_ROL: OpcjaSelect<SpeakerRole>[] = ROLE_DO_WYBORU.map((r) => ({ wartosc: r.wartosc, etykieta: r.etykieta }));

/**
 * Pola jednego mowcy: nazwa i rola (F-1: etykieta nad polem, hint pod polem).
 *
 * Komponent jest czysto prezentacyjny i kontrolowany: nie zna API ani sesji. Uzywaja go dwa
 * ekrany - okno zmiany nazwy przy zwyklej analizie (zapis od razu, PATCH) i ekran zatwierdzania
 * podzialu (zmiany czekaja do "Zatwierdz i oceń") - i dzieki temu pola wygladaja i dzialaja tak samo.
 *
 * Pusta nazwa znaczy "wroc do etykiety" (np. Mowca 1), wiec etykieta stoi w placeholderze i w hincie.
 * F-2: dwa powiazane pola stoja obok siebie i wypelniaja wiersz; na wasnym ekranie zwijaja sie do jednej kolumny.
 */
export function EdytorMowcy({
  idBazowy,
  etykieta,
  nazwa,
  rola,
  onNazwa,
  onRola,
  blad,
  wylaczony = false,
  nazwaRef,
}: {
  /** Unikalny prefiks id pol (potrzebny, gdy na ekranie stoi kilku mowcow). */
  idBazowy: string;
  /** Speaker.label: placeholder pola i nazwa, do ktorej wraca pusta nazwa. */
  etykieta: string;
  nazwa: string;
  rola: SpeakerRole;
  onNazwa: (nazwa: string) => void;
  onRola: (rola: SpeakerRole) => void;
  /** F-12: komunikat przy polu nazwy. */
  blad?: string;
  wylaczony?: boolean;
  /** Do ustawienia fokusu startowego w dialogu. */
  nazwaRef?: Ref<HTMLInputElement>;
}): React.JSX.Element {
  return (
    <div className="edytor-mowcy">
      <Input
        ref={nazwaRef}
        etykieta={`Nazwa (${etykieta})`}
        id={`${idBazowy}-nazwa`}
        hint={`Do ${MAX_ZNAKOW_NAZWY_MOWCY} znaków. Puste pole przywraca nazwę ${etykieta}.`}
        blad={blad}
        placeholder={etykieta}
        value={nazwa}
        disabled={wylaczony}
        onChange={(e) => onNazwa(e.target.value)}
      />
      <Field etykieta="Rola" id={`${idBazowy}-rola`} hint="Sprzedawca, klient albo inny uczestnik rozmowy.">
        {(atrybuty) => <Select {...atrybuty} wartosc={rola} opcje={OPCJE_ROL} onZmiana={onRola} />}
      </Field>
    </div>
  );
}
